import EfImg from '@elem/ui/ef-img';
import { FC } from 'react';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import EFWaterHeater from 'elem/ui-assets/icons/appliances/EFWaterHeater';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFWasher from 'elem/ui-assets/icons/appliances/EFWasher';
import EFOven from 'elem/ui-assets/icons/appliances/EFOven';
import EFCoffeeMaker from 'elem/ui-assets/icons/appliances/EFCoffeeMaker';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import EFLaptop from 'elem/ui-assets/icons/appliances/EFLaptop';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import { useDP3Store } from '../../DP3Provider';

const TheComp: FC = () => {
    const appItems = [
        {
            icon: <EFWaterHeater />,
            name: 'Electric Heater\n(1500W)',
        },
        {
            icon: <EFRefrigerator />,
            name: 'Refrigerator\n(200W)',
        },
        {
            icon: <EFWasher />,
            name: 'Washing Machine\n(500W)',
        },
        {
            icon: <EFWasher />,
            name: 'Clothes Dryer\n(3000W)',
        },
        {
            icon: <EFOven />,
            name: 'Electric Oven\n(1650W)',
        },
        {
            icon: <EFCoffeeMaker />,
            name: 'Coffee Maker\n(1000W)',
        },
    ];
    const cards = [
        {
            title: '4kWh in a single unit can effortlessly cover your daily high-power appliances.',
            img: 'https://websiteoss.ecoflow.com/upload/image/1726667240005/b1.png',
            hour: 12.1,
            apps: ['2.2 hours', '3 days', '7.8 hours', '1 hour', '1.9 hours', '3.3 hours'],
        },
        {
            title: 'Expandable to 8kWh (With 1 Extra Battery)',
            img: 'https://websiteoss.ecoflow.com/upload/image/1726667239533/b2.png',
            hour: 24.1,
            apps: ['4.4 hours', '5 days', '13 hours', '2.2 hours', '4 hours', '6.6 hours'],
        },
        {
            title: 'Expandable to 12kWh (With 2 Extra Batteries)',
            img: 'https://websiteoss.ecoflow.com/upload/image/1726667249264/b3.png',
            hour: 36.1,
            apps: ['6.6 hours', '8 days', '20 hours', '3.3 hours', '6 hours', '9.8 hours'],
        },
    ];

    const backs = [
        { icon: <EFPhone />, text: 'Phone\n(11W)' },
        { icon: <EFWiFi />, text: 'WIFI router\n(10W)' },
        { icon: <EFLaptop />, text: 'Laptop\n(60W)' },
        { icon: <EFLight />, text: 'Light\n(10W)' },
        { icon: <EFRefrigerator />, text: 'Refrigerator\n(200W)' },
        // { icon: <EFWasher />, text: 'Washing Machine\n(500W)' },
    ];

    const { pageStatus } = useDP3Store();
    const isPageStatusA = pageStatus === IPageStatus.statusA;

    return (
        <div
            id="dp3-teaser-H"
            className={`${css['theComp']} Freedom dp3-teaser-H GtmModuleData-section`}
            data-section-id={'dp3-G'}
            data-section-title={'Freedom from Refuelling Concerns'}
        >
            <p className={`title ${isPageStatusA ? '' : 'center'}`}>Freedom from Refuelling Concerns</p>
            <Swiper
                className={`swiper-box`}
                modules={[Scrollbar, Navigation, Pagination, Autoplay]}
                navigation={true}
                pagination={true}
                loop={true}
                spaceBetween={0}
                // autoplay={{
                //     delay: 3000,
                //     disableOnInteraction: false,
                //     pauseOnMouseEnter: true,
                // }}
                centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item`} key={k}>
                        <div className="card-left">
                            <div className="card-info">
                                <p className="card-title">{card.title}</p>
                                <ul className="card-apps">
                                    {card?.apps?.map((app: any, m: number) => (
                                        <li className="card-app" key={`${k}_${m}`}>
                                            <div className="app-icon">{appItems[m].icon}</div>
                                            <p className="app-text">{appItems[m].name}</p>
                                            <p className="app-text">{app}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="card-backup">
                                <p className="back-title">Backup Time for Appliances</p>
                                <div className="box">
                                    <ul className="backs">
                                        {backs?.map((back: any, n: number) => (
                                            <li className="back" key={`${k}_${n}`}>
                                                <div className="back-icon">{back.icon}</div>
                                                <p className="back-text">{back.text}</p>
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="time-box">
                                        <p className="time">{card.hour} Hours</p>
                                        <p className="ba">Backup Time</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-img">
                            <EfImg pc={card?.img} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default TheComp;
